import React from 'react';
import style from "../../styles/SingleProduct.module.css"

const Product_detail_info = () => {
  return (
    <div>
        <div className={style.product_description}>
            <div className={style.description_heading}>
                <h2>Information about Tata 1mg Salmon Omega 3 Fish Oil Capsule</h2>
            </div>
            <div className={style.description_content}>
                <strong>Tata 1mg Salmon Omega 3 Fish Oil Capsule</strong>
                 is a dietary supplement that promotes heart health. It is formulated with salmon oil, a rich source of omega-3 fatty acids like DHA and EPA. These can inhibit your body’s inflammatory response 
                 and may help manage symptoms associated with certain inflammatory conditions.<br/>
                 <br/><strong>Key Ingredients:</strong><br/>
                 Salmon fish oil (1000 mg), Omega-3 fatty acids (EPA- 180 mg, DHA-120 mg)<br/><br/>
                 <strong>Key Benefits:</strong><br/>
                 <ul>
                    <li>It can inhibit your body’s inflammatory response and may help manage symptoms associated with certain inflammatory conditions</li>
                </ul>
                <ul>
                    <li>Salmon oil may promote heart health by decreasing triglycerides and increasing levels of good cholesterol</li>
                </ul>
                <ul>
                    <li>It can also promote brain health and reduce the risk of age-related cognitive decline and the development of neurodegenerative conditions</li>
                </ul>
                <ul>
                    <li>Omega-3 fats support skin health and may reduce the risk of age-related eye concerns</li>
                </ul>
                <ul>
                    <li>It helps in improving flexibility and mobility of joints</li>
                </ul><br/>
                <strong>Good to Know:</strong> Contains fish oil<br/><br/>
                <strong>Effects of Deficiency:</strong><br/>
                <ul>
                    <li>High cholesterol levels</li>
                </ul>
                <ul>
                    <li>Vision problems</li>
                </ul>
                <ul>
                    <li>Joint pain</li>
                </ul><br/>
                <strong>Product Form:</strong> 
                Capsule<br/><br/><strong>Directions for Use:</strong><br/>
                Take one capsule in a day or as prescribed by your medical practitioner.<br/><br/>
                <strong>Safety Information:</strong><br/>
                <ul>
                    <li>Read the product label carefully before use</li>
                </ul>
                <ul>
                    <li>Store in a cool and dry place away from direct sunlight</li>
                </ul>
                <ul>
                    <li>Keep out of reach of children</li>
                </ul>
                <ul><li>Consult a doctor before taking any supplement</li></ul>
                <ul><li>Do not exceed the recommended dosage</li></ul>
                <ul><li>Pregnant or nursing mothers, children, and people with medical conditions must consult a physician before taking this supplement</li></ul>
                <ul><li>Do not use if the product appears to be tampered with or the seal is broken</li></ul>
                <ul><li><strong>Shelf life:</strong> 36 months</li></ul>
                <br/>
                <strong>Quick Tips:</strong> Do not consume milk after taking this medicine as it contains fish oil<br/><br/><strong>Frequently Asked Questions:</strong><br/>
                <strong>Q. Can this medicine be taken during pregnancy and breastfeeding?</strong><br/>It is best to consult your doctor before taking any supplement. Your doctor will prescribe an appropriate dose for you based on your clinical condition.<br/><br/>
                <strong>Q. Is it safe to consume alcohol while taking this medication?</strong><br/>Interaction with alcohol is unknown. It is advisable to consult your doctor before consumption.<br/><br/><strong>Q. How long does it take for this medicine to take effect?</strong><br/>There are no well-established studies to back up the onset of the effects of this medicine. However, it is best to consult with your doctor first.
                </div>
        </div>
    </div>
  )
}

export default Product_detail_info;